import React from 'react';
import './App.css';
import Hero from './components/Hero';
import Stats from './components/Stats';
import logo from './components/logo.png';
// Trucks image - place the provided image at this path: `src/components/trucks.png`
import trucks from './components/trucks.png';

function App() {
  return (
    <div className="App font-sans text-gray-900">
      <Hero />
      <Stats />

      <section id="contact" className="w-full bg-gradient-to-b from-[#7a1015] via-[#4b0b0e] to-black text-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-6 items-start">
            <div className="flex items-center justify-center md:justify-start">
              <img src={trucks} alt="VeliOğlu Araç Filosu" className="h-48 md:h-64 w-auto object-cover rounded-md shadow-none" />
            </div>

            <div className="pt-2 md:pt-6">
              <h2 id="hakkimizda" className="text-3xl md:text-4xl font-extrabold">VeliOğlu Hakkında & İletişim</h2>
              <p className="mt-4 text-gray-100/95">VeliOğlu Lojistik — bölgesel taşımacılıkta güven ve süreklilik sağlar. KOBİ'lere ve yerel işletmelere öncelik veriyoruz; amaç, büyüklük değil, güvenilir ve zamanında teslimat yapmaktır. Filomuz, eğitimli sürücülerimiz ve esnek hizmet seçeneklerimizle taşımacılığı basit ve takip edilebilir kılıyoruz.</p>

              <ul className="mt-4 space-y-2 text-sm text-gray-100/85">
                <li>• Bölgesel yük taşımacılığı ve dağıtım</li>
                <li>• Güvenli taşıma ve yük takibi</li>
                <li>• Esnek teslimat zamanları ve sözleşme seçenekleri</li>
              </ul>

              <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                <a href="tel:+905323310795" className="bg-white text-[#7a1015] px-4 py-2 rounded font-semibold inline-block">İletişime Geç</a>
                <span aria-disabled="true" className="mt-3 sm:mt-0 border border-white/30 text-white px-4 py-2 rounded inline-block opacity-60 cursor-not-allowed">Hizmetlerimiz</span>
              </div>

              <div className="mt-8 text-sm text-gray-100/90 space-y-1">
                <div className="font-medium">VeliOğlu Lojistik — İletişim</div>
                <div>Faki Yunus SARITAŞ</div>
                <div>İçmeler Mah. Kauçuk Sk. No: 27/7, Tuzla / İSTANBUL</div>
                <div>Tel: <a href="tel:+905323310795" className="text-gray-100/90 underline">0532 331 07 95</a></div>
                
                <div>E-posta: <a href="mailto:info@velioglulojistik.com" className="text-gray-100/90 underline">info@velioglulojistik.com</a></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;